module.exports = __webpack_public_path__ + "media/images/icons/working-with-bg-5d5b1681b9bcb550c615904f3d5a4282.svg";